import { Button, Typography, WithStyles, withStyles } from "@material-ui/core";
import * as moment from "moment";
import * as React from "react";

import { customerFamilyStatusItems } from "../../config";
import { getTitle } from "../../helper/functions.helper";
import { Customer } from "../../types/Customer";
import EditIcon from "../Icons/EditIcon";
import ListIcon from "../ListIcon/ListIcon";
import { styles } from "./CustomerInformations.style";

type CustomerInformationsProps = {
    customer: Customer;
    onModifyClick();
};

class CustomerInformations extends React.Component<CustomerInformationsProps & WithStyles<typeof styles>> {
    public render() {
        const { classes, theme, customer } = this.props;

        const birthDate: string = moment(customer.birthdate).format("DD/MM/YYYY");
        
        const birthPlace: string = `${customer.cityOfBirth ? customer.cityOfBirth : ""} ${
            customer.departmentOfBirth ? "(" + customer.departmentOfBirth + ")" : ""
        } - ${customer.countryOfBirth ? customer.countryOfBirth : ""}`;

        const icons = [
            {
                icon: "calendar",
                text: `Né${customer.title !== "mr" ? "e" : ""} le ${birthDate}<br>à ${birthPlace}`,
            },
            { icon: "position", text: `${customer.address}<br> ${customer.zipcode} ${customer.city}` },
            { icon: "phone", text: customer.phone },
            { icon: "mobile", text: customer.mobile },
            { icon: "contact", text: customer.email },
        ];

        return (
            <div className={classes.container}>
                <Typography variant="display1">{`${getTitle(customer.title)} ${customer.lastname} ${
                    customer.firstname
                }`}</Typography>

                <div className={classes.list}>
                    <Typography variant="body1">{customer.vocation}</Typography>
                    <Typography variant="body1">{this.getFamilyStatus(customer.familyStatus)}</Typography>
                    <ListIcon list={icons} />
                </div>

                <Button
                    className={classes.button}
                    onClick={this.props.onModifyClick}
                    type="submit"
                    variant="outlined"
                    color="primary"
                    size="small"
                >
                    <EditIcon nativeColor={theme.palette.primary.main} />
                    <span className={classes.buttonLabel}>Modifier</span>
                </Button>
            </div>
        );
    }

    private getFamilyStatus(status: Customer["familyStatus"]): string {
        const item = customerFamilyStatusItems.find((c) => c.name === status);
        return item ? item.label : "";
    }
}

export default withStyles(styles, { withTheme: true })(CustomerInformations);



// WEBPACK FOOTER //
// ./src/components/CustomerInformations/CustomerInformations.tsx